import useEditCharacterRune from '../composables/useEditCharacterRune'
//------------------------------
// edit character runes harness
//------------------------------
export default async function useEditCharacterRunesHarness(changed_runes) {
  console.log('---------------------------------------')
  console.log('IN useEditCharacterRunesHarness')
  const runeBatchSummary = (changed_runes || []).map((rune) => ({
    name: rune?.name ?? null,
    display_name: rune?.display_name ?? rune?.payload?.display_name ?? null,
    action: rune?.action ?? null,
    id: rune?.id ?? rune?.payload?.id ?? null,
    character_item: rune?.payload?.character_item ?? rune?.full_payload?.character_item ?? null,
    integrated: rune?.payload?.integrated ?? rune?.full_payload?.integrated ?? null,
    already_integrated:
      rune?.payload?.already_integrated ?? rune?.full_payload?.already_integrated ?? null,
  }))
  console.log('[RECOVERABLE_ARTEFACT_TRACE] useEditCharacterRunesHarness batch', runeBatchSummary)
  console.log(
    '[RUNE_EDIT_TRACE] useEditCharacterRunesHarness batch json',
    JSON.stringify(runeBatchSummary),
  )
  //-------------------------------------------
  // manages all character rune updates (CRUD)
  //-------------------------------------------
  //--------------------------------------------------------------
  // process rune updates one at a time (not concurrently) - the
  // dev/sqlite backend only supports a single writer at a time,
  // so firing these in parallel (Promise.all) can trigger
  // "database is locked" errors when a single logical operation
  // (e.g. deleting an artefact with multiple linked runes)
  // needs to persist more than one rune change.
  //--------------------------------------------------------------
  const results = []
  for (const r of changed_runes) {
    console.log('IN useEditCharacterRunesHarness - PROCESSING RUNE:', r)
    //-------------------
    // call api function
    //-------------------
    // eslint-disable-next-line no-await-in-loop
    results.push(await useEditCharacterRune(r))
  }
  //-----------------------------
  // optionally return responses
  //-----------------------------
  // if (returnResponses) return results
  return results
  //----------------------------------------------
  // else no response (caller awaited completion)
  //----------------------------------------------
  // return
}
